// @ts-strict-ignore

import { StringValueInLocalesVO } from '@project/components/article/model/vo/property.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ArticleToColorValueInLocalesVO')
export class ArticleToColorValueInLocalesVO {

  @JsonProperty('articleId', 'Number')
  public articleId = undefined;

  @JsonProperty('articleVersion', 'Number')
  public articleVersion = undefined;

  @JsonProperty('colorInLocales', 'ColorValueInLocalesVO')
  public colorInLocales: ColorValueInLocalesVO;
}

@JsonObject('ColorValueInLocalesVO')
export class ColorValueInLocalesVO extends StringValueInLocalesVO {

  @JsonProperty('colorId', 'Number')
  public colorId = undefined;

  @JsonProperty('rgbValue', 'Number')
  public rgbValue = undefined;

}
